import * as React from "react"
import type { SVGProps } from "react"
const SvgTrendingUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.7 17.63a1 1 0 0 1-.29-.72q.01-.4.29-.68l5.27-5.35q.58-.58 1.43-.58t1.42.57l2.58 2.6 5.2-5.15H17a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.7.29-.3.71-.3h4q.42 0 .71.3.3.27.29.7v4q0 .43-.29.72t-.71.29a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7v-1.6l-5.18 5.17q-.57.57-1.42.57t-1.43-.57L9.4 12.32l-5.3 5.3a1 1 0 0 1-.7.28 1 1 0 0 1-.7-.27" />
  </svg>
)
export default SvgTrendingUp
